import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { ScreenPermissionServiceService } from 'src/app/shared/services/screen-permission-service.service';

@Component({
    selector: 'app-products-info-confg',
    templateUrl: './products-info-confg.component.html',
    styleUrls: ['./products-info-confg.component.scss'],
    standalone: false
})
export class ProductsInfoConfgComponent implements OnInit {

  navLinks: any[];
  activeLinkIndex = -1;
activeTab: 'intake' | 'scheduler' = 'intake';
  isSidenavOpen=true;
  selectedProductDetails:any=null;
  constructor(private router: Router,private screenPermissionServiceService:ScreenPermissionServiceService,) {
    this.navLinks = [
      
      {
        label: 'Product Safety Strategy',
        link: './jsip-productstrategy',
        index: 0
      },
      {
        label: 'Review & Approve',
        link: './jsip-review&approve',
        index: 1
      },
      
    ];
   }

  ngOnInit(): void {

    /**
     * @Modified By Rahul Vk 
     * 
     * @Desc : - Instead of Subscribing  to all router events , 
     *            we can directly filter for NavigationEnd events using the filter operator from rxjs. 
     *            This way, we only subscribe to the relevant events and avoid unnecessary processing for other types of router events.
     *      
     *          - Avoided Multiple recursive calls when the user clicks on same tab or switch tabs 
     */
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((res) => {
      const activeLink = this.router.url.split('/').pop();

      this.activeLinkIndex = this.navLinks.indexOf(this.navLinks.find(tab => tab.link === '.' + this.router.url));

      console.log(this.activeLinkIndex);
      console.log(activeLink);

      if (activeLink) {
        this.screenPermissionServiceService.load(activeLink).subscribe();
      }
    });
  }

}
